import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      withoutAnimation: false
    },
    device: 'desktop'
  },
  mutations: {

  },
  actions: {
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js